import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
import NewCoupon from "./NewCoupon.vue";
export default {
  components: {
    NewCoupon: NewCoupon
  },
  name: "CouponItem.vue",
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  data: function data() {
    return {
      couponItem: _objectSpread({}, this.item),
      editCouponPopup: false
    };
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  watch: {
    item: function item(newValue) {
      this.couponItem = newValue;
    }
  },
  methods: {
    couponEdited: function couponEdited(coupon) {
      this.couponItem = coupon;
      this.editCouponPopup = false;
    },
    deleteCoupon: function deleteCoupon(couponId) {
      var _this = this;

      this.$vs.loading();
      providerApiService.deleteCoupon(this.currentProvider.id, couponId).then(function () {
        _this.$vs.notify({
          text: "کد تخفیف با موفقیت حذف شد.",
          color: "success",
          position: "bottom-center"
        });

        _this.$emit("couponDeleted", _this.couponItem);
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    }
  }
};